// Import styles
import '../styles/theme.scss';

import _ from 'lodash';
import Sections from './helpers/SectionManager';

// Import sections
import ProductSlider from './sections/ProductSlider';
import ProductSpecialOrder from './sections/ProductSpecialOrder';
import RotatingGrid from './sections/RotatingGrid';
import Slider from './sections/Slider';

// Plugins
// import rimg from '@pixelunion/rimg-shopify';

// init plugins
// rimg.init();


const sections = new Sections();
sections.register('custom-slider', (section) => new Slider(section));
sections.register('rotating-grid', (section) => new RotatingGrid(section));
sections.register('product-special-order', (section) => new ProductSpecialOrder(section));
sections.register('products-slider', (section) => new ProductSlider(section));
